<div class="container p-5">
    <div class="row">
        <h1 class="mb-0">Phone numbers</h1>
        <h4 class="fw-light mb-0">Manage your phone numbers</h4>
    </div>

    <mat-divider class="mt-4"></mat-divider>

    <app-user-phone-numbers></app-user-phone-numbers>
</div>